import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { withRouteAccessCheck } from "../../../../../app/Hoc/WithLoginAceessCheck.js";
import { deleteSubscriber } from "../../../../../app/redux/slices/app/manageFiberServiceSlice.js";
import ConfirmationDialog from "../../../../components/customComponents/ConfirmationModal/index";
import CustomSnackbar from "../../../../components/customComponents/CustomSnackbar/index";
import { validateForm } from "../../../../components/customComponents/customValidation/index";
import {
  getPremiseDetails,
  fetchONTdetailsBySlNumber,
  updatePremiseServicePointDetails,
  updateOrderDetails,
  updateCaseDetails,
} from "../../../../../app/redux/slices/app/fiberEnrollmentIssueSlice.js";
import { CircularProgress } from "@mui/material";
import { searchPremisesByTerm } from "../../../../../app/redux/slices/app/premiseSlice.js";
import { getCommunicationContacts } from "../../../../../app/redux/slices/app/communicationSlice";
import ModalComponent from "../../../../components/customComponents/ModalComponent/ModalComponent.jsx";
import AddCommunity from "./AddCommunity.jsx";
import Pagination from "../../../../components/customComponents/pagination.jsx";
import {
  formatTwoDigitDate,
  formatToMMDDYYYY,
} from "../../../../../app/utils/utils";
import {
  getsignedCommunitiesList,
  deleteCommunity,
} from "../../../../../app/redux/slices/app/signedCommunities.js";
import { formatDate, capitalize } from "../../../../../app/utils/utils";
import BillingHistoryLoader from "../../ManagePreference/BillingHistoryLoader.jsx";

const CommunityManagement = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [confirmObject, setconfirmObject] = useState({});
  const [editData, setEditModalData] = useState({});
  const [clear, setModDataClear] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showMessage, setShowMessage] = useState("");
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [modalOpenpayment, setModalOpenpayment] = useState(false);
  const [stateNo, setStatementNum] = useState(false);
  const [paymentAmount, setPaymentAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [modalData, setModalData] = useState({});
  const [filteredList, setFilteredList] = useState([]);
  const [searchList, setSearchList] = useState([]);

  const [pdfUrl, setPdfUrl] = useState("");

  const [page, setPage] = useState({
    totalCount: 51,
    currentPage: 1,
    pageCount: 3,
    itemsPerPage: 50,
  });

  const selectedAccount = useSelector(
    (state) => state?.userDetailSlice?.selectedAccount
  );

  const [searchText, setSearchText] = useState("");

  const billingHistoriesData = useSelector(
    (state) => state?.billingSlice.billingHistoriesData
  );



  const [filter, setFilter] = useState({
    pageNumber: 1,
    pageSize: 50,
  });
  useEffect(() => {
    setFilter({
      ...filter,
      pageNumber: page.currentPage,
      pageSize: page.itemsPerPage,
    });
  }, [page.currentPage, page.itemsPerPage]);
  const onCloseModal = () => {
    setModalOpen(false);
    setEditModalData({});
    LoadGridData();
    setModDataClear(true);
  };
  const onOpenModal = () => {
    setModalOpen(true);
    setModDataClear(false);
  };

  const updateSearchText = (e) => {
    setSearchText(e);
  };

  useEffect(() => {
    LoadGridData();
  }, [dispatch, filter.pageNumber, filter.pageSize]);

  const LoadGridData = async () => {
    setLoading(true);
    const res = await dispatch(getsignedCommunitiesList({ ...filter }));
    if (res?.payload?.data?.data?.length > 0) {
      setLoading(false);
      setFilteredList(res?.payload?.data?.data);
      setSearchList(res?.payload?.data?.data);
      setPage({
        ...page,
        totalCount: res?.payload?.data?.totalCount,
      });
    } else {
      setLoading(false);
      setShowMessage("Failed to load the data");
      setOpenSnackbar(true);
    }
  };

 

  const btnSearch = async () => {
    if (searchText) {
      let tempData = filteredList?.filter(
        (a) => a?.name?.toLowerCase().includes(searchText.toLowerCase())
      );
      setSearchList(tempData);
    } else {
      setSearchList(filteredList);
    }
  };
  const openDialog = (obj) => {
    setconfirmObject(obj);
    setDialogOpen(true);
  };

  const closeDialog = () => {
    setconfirmObject({});
    setDialogOpen(false);
    LoadGridData();
  };
  const confirmAction = () => {
    handleRemoveClick();
  };
  const handleRemoveClick = async () => {
    const res = await dispatch(deleteCommunity(confirmObject));
    if (res?.payload?.status === 204) {
      setShowMessage("Community deleted successfully");
      setOpenSnackbar(true);
    } else {
      setShowMessage("Failed to delete the community");
      setOpenSnackbar(true);
    }
    closeDialog();
  };
  <style>
    {`
    .fa-solid, .fas {
      font-family: "Font Awesome 6 Pro" !important;
      font-weight: 900 !important;
    }
  `}
  </style>;
  return (
    <>
      <ModalComponent
        openModal={modalOpen}
        onClose={onCloseModal}
        modalId="AddCommunity"
        isExtralarge
        mainheading="Add Community"
        modalContent={
          <AddCommunity
            onClose={onCloseModal}
            editData={editData}
            clear={clear}
          />
        }
      />

      <ConfirmationDialog
        title="Confirm Action"
        open={dialogOpen}
        onClose={closeDialog}
        onConfirm={confirmAction}
        content="Are you sure you want to delete this community?"
      />
      <CustomSnackbar
        openSnackbar={openSnackbar}
        severity={
          showMessage.includes("Failed") || showMessage.includes("Error")
            ? "error"
            : "success"
        }
        message={showMessage}
        autoHideDuration={3000}
        handleClose={() => setOpenSnackbar(false)}
      />

      <div class="row min-h-100">
        <div class="col-xxl-12">
          <div class="card card-custom card-xxl-stretch manage-fiber-service">
            <div class="card-body">
              <div class="mb-5 d-flex justify-content-between align-items-stretch with_hr_tabs">
                <div className="custom-search">
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      id="searchInput"
                      placeholder="Search by Name"
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      value={searchText}
                      onChange={(e) => {
                        e.preventDefault();
                        updateSearchText(e.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && !e.shiftKey) {
                          e.preventDefault();
                          btnSearch();
                        }
                      }}
                    />
                    {searchText && (
                      <span
                        className="input-group-text cursor-pointer cp"
                        onClick={() => {
                          updateSearchText("");
                          setSearchList(
                            filteredList
                          );
                        }}
                        title="Clear"
                      >
                        <i className="fa fa-times"></i>
                      </span>
                    )}
                    <span
                      className="input-group-text cursor-pointer cp"
                      id="basic-addon1"
                      onClick={(e) => {
                        e.preventDefault();
                        btnSearch();
                      }}
                    >
                      <i className="fa-regular fa-magnifying-glass"></i>
                    </span>
                  </div>
                </div>
                <div class="head_btn align-items-center d-flex gap-10px">
                  <a
                    class="btn btn-custom electric_cobalt min-h-55px"
                    onClick={onOpenModal}
                  >
                    + Add Community
                  </a>
                </div>
              </div>

              <div class="row justify-content-center">
                <div class="table-reponsive">
                  <table class="table v-align-middle">
                    <thead>
                      <tr>
                        <th></th>
                        <th>Name</th>
                        <th class="text-center">Project Name</th>
                        <th class="text-center">Unsigned JV Placeholder</th>
                        <th class="text-center">Aliases</th>
                        <th class="text-center">Files</th>
                        <th class="text-center">Owner</th>
                        <th class="text-center">Developer</th>
                        <th class="text-center">Developer ID</th>
                        <th class="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!loading &&
                        searchList?.length > 0 &&
                        searchList?.map((item, index) => {
                          const isOpen = openIndex === index;

                          return (
                            <React.Fragment key={index}>
                              <tr
                                className="clickable"
                                onClick={() =>
                                  setOpenIndex(isOpen ? null : index)
                                }
                              >
                                <td>
                                  <a href="javascript:void(0)">
                                    <i
                                      className={`fa-solid ${
                                        isOpen
                                          ? "fa-chevron-down"
                                          : "fa-chevron-right"
                                      }`}
                                      style={{
                                        transition: "transform 0.2s ease",
                                        fontFamily: "Font Awesome 6 Pro",
                                        fontWeight: 900,
                                      }}
                                    ></i>
                                  </a>
                                </td>
                                <td className="text-blue">{item?.name}</td>
                                <td className="text-center text-blue">
                                  {item?.projectName}
                                </td>
                                <td className="text-center text-blue">
                                  {item?.unsignedJvPlaceholder || "--"}
                                </td>
                                <td className="text-center text-blue">
                                  {item?.aliases || "--"}
                                </td>
                                <td className="text-center text-blue">
                                  <a
                                    href={item?.files}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={(e) => {
                                      e.stopPropagation(); // prevent accordion toggle
                                    }}
                                  >
                                    File 1
                                  </a>
                                </td>
                                <td className="text-center text-blue">
                                  {item?.owner}
                                </td>
                                <td className="text-center text-blue">
                                  {item?.developer}
                                </td>
                                <td className="text-center text-blue">
                                  {item?.developerId}
                                </td>
                                <td className="text-center text-blue">
                                  <button
                                    className="btn btn-custom outline-light text-success"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      onOpenModal();
                                      setEditModalData(item);
                                    }}
                                  >
                                    <i className="fa-solid fa-pencil"></i>
                                  </button>
                                  &nbsp;
                                  <button
                                    className="btn btn-custom outline-light text-danger"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      openDialog(item);
                                    }}
                                  >
                                    <i className="fa-solid fa-trash"></i>
                                  </button>
                                </td>
                              </tr>

                              {isOpen && (
                                <tr className="bg-light">
                                  <td colSpan="10">
                                    <table className="table border v-align-middle">
                                      <tbody>
                                        <tr>
                                          <th style={{ width: "250px" }}>
                                            Project ID
                                          </th>
                                          <td className="text-blue">
                                            {item?.projectId}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Franchise Status</th>
                                          <td className="text-blue">
                                            {item?.franchiseStatus || "N/A"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Memo Recorded?</th>
                                          <td class="text-blue">
                                            {item?.notes || "--"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>OMTT</th>
                                          <td class="text-blue">
                                            {item?.omtt || "--"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Project Type</th>
                                          <td class="text-blue">
                                            {item?.projectType}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Gas # Lots</th>
                                          <td class="text-blue">
                                            {item?.gasLots}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Fiber # Lots</th>
                                          <td class="text-blue">
                                            {item?.fiberLots}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Gas/Fiber/Both</th>
                                          <td class="text-blue">
                                            {item?.gasFiberBoth}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Fiber Agreement Structure</th>
                                          <td class="text-blue">
                                            {item?.agreementType}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Bulk/Individual Bill</th>
                                          <td class="text-blue">
                                            {item?.bulkIndividualBill}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>HOA/Bulk</th>
                                          <td class="text-blue">
                                            {item?.hoaBulk || "N/A"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>TAA</th>
                                          <td class="text-blue">
                                            {item?.taa || "N"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>JV</th>
                                          <td class="text-blue">
                                            {item?.jv || "N"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>JV Entity</th>
                                          <td class="text-blue">
                                            {item?.jvEntity || "--"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Market</th>
                                          <td class="text-blue">
                                            {item?.market || "--"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>County</th>
                                          <td class="text-blue">
                                            {item?.county}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>City</th>
                                          <td class="text-blue">
                                            {item?.city}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Date Executed Gas</th>
                                          <td class="text-blue">
                                            {formatDate(
                                              item?.dateExecutedGas
                                            ) || "--"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Date Executed Fiber</th>
                                          <td class="text-blue">
                                            {formatDate(
                                              item?.dateExecutedFiber
                                            ) || "--"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Solar Head End</th>
                                          <td class="text-blue">
                                            {item?.solarHeadEnd || "--"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>1 GBPS Price</th>
                                          <td class="text-blue">
                                            {item?.gbpsPrice1 || "--"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Line Service</th>
                                          <td class="text-blue">
                                            {item?.lineService || "--"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Est. First Capex Spend</th>
                                          <td class="text-blue">
                                            {" "}
                                            {formatDate(
                                              item?.estFirstCapexSpend
                                            ) || "--"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Est FSN/Co Date</th>
                                          <td class="text-blue">
                                            {formatDate(item?.estFsnCoDate) ||
                                              "--"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Comments</th>
                                          <td class="text-blue">
                                            {item?.comments || ""}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Gas $/Lot</th>
                                          <td class="text-blue">
                                            {item?.gasPerLot || "N/A"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Gas Royalty %</th>
                                          <td class="text-blue">
                                            {item?.gasRoyaltyPercent || "N/A"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Fiber $/Lot</th>
                                          <td class="text-blue">
                                            {item?.fiberPerLot || "--"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Fiber Royalty %</th>
                                          <td class="text-blue">
                                            {item?.fiberRoyaltyPercent || "--"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Buyback</th>
                                          <td class="text-blue">
                                            {item?.buyback || "--"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Term</th>
                                          <td class="text-blue">
                                            {item?.term || "--"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Gas Cash Upfront</th>
                                          <td class="text-blue">
                                            {item?.gasCashUpfront || "--"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Fiber Cash Upfront</th>
                                          <td class="text-blue">
                                            {item?.fiberCashUpfront || "--"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Cash Upfront Total</th>
                                          <td class="text-blue">
                                            {" "}
                                            {item?.cashUpfrontTotal || "--"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Notify</th>
                                          <td class="text-blue">
                                            {" "}
                                            {item?.notify}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Status</th>
                                          <td class="text-blue">
                                            {item?.status}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>State</th>
                                          <td class="text-blue">
                                            {item?.state}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          );
                        })}

                      {loading && <BillingHistoryLoader />}
                      {!loading && searchList?.length === 0 && (
                        <tr>
                          <td colSpan="8" className="ndf">
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="card-footer text-end border-0">
              {page.totalCount > 0 && (
                <Pagination page={page} setPage={setPage} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouteAccessCheck(CommunityManagement);
